import React, { useEffect } from "react";
import { RouteName } from "../utils/route.utils";
import { contactEmail, contactNumber } from "../utils/constants";
import { faqList } from "../utils/constants/ContactPage";
import { handleWebPageOpenEvent } from "../utils/utils";
import { useSelector } from "react-redux";
import Head from "next/head";
import TAGS from "../public/headJson.json";
import ContactUs from "../components/ContactUs";

const ContactUsPage = (props) => {
  const { webviewEvent } = props;
  const firebase_uid = useSelector((state) => state?.currentUser?.firebaseUID);
  const structDataFaq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList?.map((faq) => {
      return {
        "@type": "Question",
        name: faq?.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq?.answer,
        },
      };
    }),
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "KEYARO EDUTECH PRIVATE LIMITED",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Bengaluru",
      addressRegion: "Karnataka",
      addressCountry: "IN",
    },
    email: contactEmail,
    telephone: contactNumber,
  };

  const contactUsSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "Contact Us",
    url: "https://seekho.in/contact-us",
    description: TAGS.contactUs.description,
    publisher: {
      "@type": "Organization",
      name: "KEYARO EDUTECH PRIVATE LIMITED",
    },
  };

  useEffect(() => {
    handleWebPageOpenEvent({
      type: "/contact-us",
      webviewEvent,
      firebase_uid,
    });
  }, [firebase_uid]);

  return (
    <>
      <Head>
        <title>{TAGS.contactUs.title}</title>
        <meta name="title" content={TAGS.contactUs.title} />
        <meta name="description" content={TAGS.contactUs.description} />
        <link rel="canonical" href={RouteName.contactUs} />

        {/* Facebook / Open Graph */}
        <meta property="og:url" content={RouteName.contactUs} />
        <meta property="og:title" content={TAGS.contactUs.title} />
        <meta property="og:description" content={TAGS.contactUs.description} />
        <meta property="og:image" content={TAGS.landingPage.imageUrl} />
        <meta property="og:image:alt" content="Seekho" />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.contactUs} />
        <meta property="twitter:title" content={TAGS.contactUs.title} />
        <meta
          property="twitter:description"
          content={TAGS.contactUs.description}
        />
        <meta property="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@seekhoapp" />
        <meta property="twitter:image" content={TAGS.landingPage.imageUrl} />

        <script
          type="application/lg+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(contactUsSchema) }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structDataFaq) }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      </Head>

      <section>
        <div>
          <ContactUs />
        </div>
      </section>
    </>
  );
};

export default ContactUsPage;
